import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "#28292F", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 15 6-6 6 6" }));
export default SvgChevronUp;
